import { requireAuth } from '@/features/auth/guards/require-auth'
import { UnitsPage } from '@/features/references/units/units-page'
import { unitsListQuery } from '@/features/references/units/units-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/references/units')({
  beforeLoad: requireAuth,
  loader: ({ context }) => context.queryClient.ensureQueryData(unitsListQuery()),
  component: UnitsPage,
  staticData: { crumb: messages.crumbs.refUnits },
})
